import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import { Link, Text } from '@chakra-ui/react';
import Widget from './Widget';
import { CircleIndicator } from '../indicators';
import { useDataQualityKPI } from '../../context/reports-api-hooks';

export default function DataQualityWidget() {
  const { data, isLoading, isError } = useDataQualityKPI();
  const dqScore = data?.Score;
  const lockYear = data?.LockYear;

  const title = 'Data Quality';
  const description = 'Data quality score';

  // If there is an error we want to hide the widget
  if (isError) return null;

  return (
    <Widget
      link="/performance/dashboard/data-quality"
      title={title}
      description={description}
      lockYear={lockYear}
      quarter={null}
      isLoading={isLoading && !data}
      moreInfoContent={(
        <>
          <Text fontSize="sm" mb={2}>
            The overall data quality score is an indication of the quality of available data to support investment and decision-making processes.
          </Text>
          <Text fontSize="sm" mb={2}>
            The score is a weighted score based on the data quality metric results for the latest completed financial year. The results are weighted by the level of importance of each metric (High, moderate or low), see the score calculation link below.
          </Text>
          <Text fontSize="sm" mb={2}>
            Further references:
            <br />
            <Link href="https://www.nzta.govt.nz/assets/Road-Efficiency-Group/docs/practice-overviews/REG-practice-overview-data-quality-framework.pdf" isExternal>Data quality framework overview</Link>
            <br />
            <Link href="https://www.nzta.govt.nz/assets/Road-Efficiency-Group/docs/practice-overviews/REG-practice-overview-data-quality-dimensions.pdf" isExternal>Data quality dimensions overview</Link>
            <br />
            <Link href="https://www.nzta.govt.nz/assets/Road-Efficiency-Group/docs/RCA-data-quality-reports/asset-management-data-quality-report-score-calculation.pdf" isExternal>Overall Asset Management Score calculation</Link>
          </Text>
          <Text fontSize="xs" mt={2}>
            Source: Road Efficiency Group Te Ringa Maimoa annual data quality assessment and reporting undertaken within Transport Insights.
          </Text>
        </>
      )}
    >
      <CircleIndicator
        size={100}
        colour={CHART_COLOURS.darkblue}
        value={dqScore}
        isLoading={isLoading && !data}
      />
    </Widget>
  );
}
